module.exports = __webpack_public_path__ + "img/PorkArgentina.ca69d362.png";